import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { VehicleAutocompleteRequest, VehicleAutocompleteResult } from "./types";

const AUTOCOMPLETE_VEHICLES = ApiRequestAdapter.create("/vehicles/autocomplete", HttpMethod.GET);

export const vehicleAutocompleteApi = {
  autocompleteVehicles: (request: VehicleAutocompleteRequest): AxiosPromise<VehicleAutocompleteResult> => {
    return apiService.get(AUTOCOMPLETE_VEHICLES.url, { params: request });
  },
};
